/** Canonical sector / industry values (stored English; labelKeys for i18n display). */
export const SECTOR_OPTIONS = [
  { value: "Accounting and Finance", labelKey: "events.sectors.accountingFinance" },
  { value: "Agriculture & Farming", labelKey: "events.sectors.agricultureFarming" },
  { value: "Arts & Creative", labelKey: "events.sectors.artsCreative" },
  { value: "Business Services", labelKey: "events.sectors.businessServices" },
  { value: "Construction & Property", labelKey: "events.sectors.constructionProperty" },
  { value: "Education & Training", labelKey: "events.sectors.educationTraining" },
  { value: "Energy & Environment", labelKey: "events.sectors.energyEnvironment" },
  {
    value: "Engineering & Manufacturing",
    labelKey: "events.sectors.engineeringManufacturing",
  },
  { value: "Food & Beverage", labelKey: "events.sectors.foodBeverage" },
  {
    value: "Government & Public Services",
    labelKey: "events.sectors.governmentPublicServices",
  },
  { value: "Healthcare & Medical", labelKey: "events.sectors.healthcareMedical" },
  { value: "Hospitality & Tourism", labelKey: "events.sectors.hospitalityTourism" },
  { value: "HR & Recruitment", labelKey: "events.sectors.hrRecruitment" },
  { value: "Insurance", labelKey: "events.sectors.insurance" },
  { value: "Legal & Compliance", labelKey: "events.sectors.legalCompliance" },
  {
    value: "Marketing, Advertising & Digital",
    labelKey: "events.sectors.marketingAdvertisingDigital",
  },
  {
    value: "Sports, Media & Entertainment",
    labelKey: "events.sectors.sportsMediaEntertainment",
  },
  { value: "Retail & E-Commerce", labelKey: "events.sectors.retailEcommerce" },
  { value: "Sales & Customer Service", labelKey: "events.sectors.salesCustomerService" },
  { value: "Science & Research", labelKey: "events.sectors.scienceResearch" },
  { value: "Technology & IT", labelKey: "events.sectors.technologyIt" },
  { value: "Telecommunication", labelKey: "events.sectors.telecommunication" },
  { value: "Third Sector", labelKey: "events.sectors.thirdSector" },
  { value: "Transport & Logistics", labelKey: "events.sectors.transportLogistics" },
  { value: "Other", labelKey: "events.sectors.other" },
] as const;

export type SectorValue = (typeof SECTOR_OPTIONS)[number]["value"];

export const SECTORS: readonly SectorValue[] = SECTOR_OPTIONS.map((o) => o.value);

/** Alphabetically sorted for dropdowns. */
export const SORTED_SECTORS: readonly SectorValue[] = [...SECTORS].sort((a, b) =>
  a.localeCompare(b),
);

export const OTHER_SECTOR_VALUE = "Other" as const satisfies SectorValue;

/** Map stored English API value → localized display label; unknown values pass through. */
export function getSectorDisplayLabel(
  value: string | null | undefined,
  t: (key: string) => string,
): string {
  const trimmed = String(value ?? "").trim();
  if (!trimmed) return "";
  const opt = SECTOR_OPTIONS.find((o) => o.value === trimmed);
  return opt ? t(opt.labelKey) : trimmed;
}
